/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_5_PInputs */

const en_cp_cmp_5_p = /** @type {(inputs: Cp_Cmp_5_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemastik · KMIPN · club hackathons`)
};

const id_cp_cmp_5_p = /** @type {(inputs: Cp_Cmp_5_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemastik · KMIPN · hackathon himpunan`)
};

/**
* | output |
* | --- |
* | "Gemastik · KMIPN · club hackathons" |
*
* @param {Cp_Cmp_5_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_5_p = /** @type {((inputs?: Cp_Cmp_5_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_5_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_5_p(inputs)
	return en_cp_cmp_5_p(inputs)
});